export const LimitIcon = () => {
  return (
    <svg
      width="32"
      height="32"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g filter="url(#filter0_ii_13547_24640)">
        <rect
          width="24"
          height="24"
          rx="7.2"
          fill="url(#paint0_linear_13547_24640)"
        />
        <g filter="url(#filter1_dd_13547_24640)">
          <path
            d="M12.0003 5.39999C12.3045 5.40019 12.6042 5.47006 12.8738 5.60366C13.1435 5.73726 13.3752 5.93064 13.5493 6.16739L13.6176 6.26579L18.948 14.7102C19.1077 14.973 19.1946 15.27 19.2005 15.5733C19.2063 15.8766 19.131 16.1764 18.9816 16.4446C18.8321 16.7128 18.6134 16.9406 18.3459 17.1068C18.0785 17.2729 17.7709 17.3719 17.4521 17.3946L17.3257 17.4H6.6686C6.34943 17.3964 6.03643 17.3161 5.75877 17.1667C5.48111 17.0173 5.24784 16.8036 5.08069 16.5456C4.91355 16.2875 4.81798 15.9935 4.80289 15.6909C4.78781 15.3883 4.8537 15.0871 4.99442 14.8152L5.05827 14.7018L10.3849 6.26279C10.5534 5.9994 10.7905 5.78165 11.0735 5.63052C11.3564 5.4794 11.6756 5.4 12.0003 5.39999ZM12.0446 13.8L11.9643 13.8042C11.8106 13.8215 11.669 13.8918 11.5662 14.0016C11.4635 14.1114 11.4067 14.2531 11.4067 14.4C11.4067 14.5469 11.4635 14.6886 11.5662 14.7984C11.669 14.9082 11.8106 14.9784 11.9643 14.9958L12.0382 15L12.1185 14.9958C12.2722 14.9784 12.4138 14.9082 12.5166 14.7984C12.6193 14.6886 12.6761 14.5469 12.6761 14.4C12.6761 14.2531 12.6193 14.1114 12.5166 14.0016C12.4138 13.8918 12.2722 13.8215 12.1185 13.8042L12.0446 13.8ZM12.0382 8.99999C11.8834 9.00001 11.7339 9.05397 11.6182 9.15162C11.5025 9.24928 11.4285 9.38384 11.4104 9.52979L11.406 9.59999V12L11.4104 12.0702C11.4287 12.216 11.5027 12.3504 11.6184 12.4479C11.7341 12.5455 11.8835 12.5993 12.0382 12.5993C12.193 12.5993 12.3424 12.5455 12.4581 12.4479C12.5738 12.3504 12.6478 12.216 12.6661 12.0702L12.6705 12V9.59999L12.6661 9.52979C12.6479 9.38384 12.574 9.24928 12.4583 9.15162C12.3426 9.05397 12.1931 9.00001 12.0382 8.99999Z"
            fill="url(#paint1_linear_13547_24640)"
            shapeRendering="crispEdges"
          />
          <path
            d="M12 5.6998C12.2585 5.69997 12.5124 5.75985 12.7402 5.87265C12.911 5.95723 13.0631 6.06965 13.1895 6.2037L13.3076 6.34531L13.3711 6.4371L18.6943 14.8707C18.8251 15.0876 18.8955 15.331 18.9004 15.5787C18.9052 15.8282 18.8436 16.0761 18.7197 16.2984C18.5957 16.521 18.4129 16.7122 18.1875 16.8521C17.9621 16.9921 17.7015 17.0761 17.4307 17.0953L17.3125 17.1002H6.67188C6.40079 17.0971 6.13564 17.0289 5.90137 16.9029C5.667 16.7768 5.471 16.597 5.33203 16.3824C5.19331 16.1682 5.11501 15.9252 5.10254 15.6764C5.0902 15.4288 5.14264 15.1809 5.25781 14.9566L5.31934 14.8492L10.6377 6.42441C10.7777 6.20549 10.976 6.02267 11.2148 5.89511C11.4537 5.76757 11.7241 5.69986 12 5.6998ZM11.9482 13.5045L11.9307 13.5064C11.7084 13.5315 11.5006 13.6332 11.3477 13.7965C11.1943 13.9604 11.1064 14.175 11.1064 14.4C11.1064 14.625 11.1943 14.8396 11.3477 15.0035C11.5006 15.1668 11.7084 15.2685 11.9307 15.2935C11.9362 15.2942 11.9417 15.2952 11.9473 15.2955L12.0215 15.2994C12.0322 15.3 12.043 15.3 12.0537 15.2994L12.1338 15.2955C12.1398 15.2952 12.1464 15.2942 12.1523 15.2935C12.3746 15.2684 12.5824 15.1668 12.7354 15.0035C12.8887 14.8396 12.9766 14.625 12.9766 14.4C12.9766 14.175 12.8887 13.9604 12.7354 13.7965C12.5824 13.6331 12.3746 13.5316 12.1523 13.5064L12.1357 13.5045L12.0615 13.5006H12.0293L11.9482 13.5045ZM12.9697 9.58066L12.9658 9.51132L12.9639 9.49277L12.9492 9.40976C12.9067 9.21961 12.8014 9.04903 12.6514 8.92245C12.4802 8.77811 12.2619 8.69983 12.0381 8.6998C11.8142 8.69985 11.5959 8.77804 11.4248 8.92245C11.2533 9.06722 11.14 9.26947 11.1123 9.49277L11.1113 9.51132L11.1064 9.58066V12.0191L11.1113 12.0894C11.1117 12.0953 11.1116 12.1012 11.1123 12.107C11.1403 12.3301 11.2534 12.5328 11.4248 12.6773C11.5959 12.8215 11.8144 12.899 12.0381 12.899C12.2618 12.899 12.4802 12.8216 12.6514 12.6773C12.8229 12.5328 12.9359 12.3301 12.9639 12.107C12.9646 12.1012 12.9654 12.0953 12.9658 12.0894L12.9697 12.0191C12.9701 12.0129 12.9707 12.0059 12.9707 11.9996V9.60019C12.9707 9.59389 12.9701 9.58694 12.9697 9.58066Z"
            stroke="url(#paint2_linear_13547_24640)"
            strokeWidth="0.6"
            strokeLinecap="round"
            strokeLinejoin="round"
            shapeRendering="crispEdges"
          />
        </g>
      </g>
      <defs>
        <filter
          id="filter0_ii_13547_24640"
          x="0"
          y="-1.2"
          width="24"
          height="25.2"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="BackgroundImageFix"
            result="shape"
          />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="-1.2" />
          <feGaussianBlur stdDeviation="1.2" />
          <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.5 0"
          />
          <feBlend
            mode="normal"
            in2="shape"
            result="effect1_innerShadow_13547_24640"
          />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feMorphology
            radius="0.6"
            operator="erode"
            in="SourceAlpha"
            result="effect2_innerShadow_13547_24640"
          />
          <feOffset />
          <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
          />
          <feBlend
            mode="normal"
            in2="effect1_innerShadow_13547_24640"
            result="effect2_innerShadow_13547_24640"
          />
        </filter>
        <filter
          id="filter1_dd_13547_24640"
          x="2.40078"
          y="4.19999"
          width="19.2004"
          height="16.8"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="1.2" />
          <feGaussianBlur stdDeviation="1.2" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_13547_24640"
          />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="0.6" />
          <feGaussianBlur stdDeviation="0.3" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
          />
          <feBlend
            mode="normal"
            in2="effect1_dropShadow_13547_24640"
            result="effect2_dropShadow_13547_24640"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect2_dropShadow_13547_24640"
            result="shape"
          />
        </filter>
        <linearGradient
          id="paint0_linear_13547_24640"
          x1="12"
          y1="0"
          x2="12"
          y2="24"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#F3BD7F" />
          <stop offset="1" stopColor="#D9622B" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_13547_24640"
          x1="12.0008"
          y1="5.39999"
          x2="12.0008"
          y2="17.4"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="white" />
          <stop offset="1" stopColor="white" stopOpacity="0.4" />
        </linearGradient>
        <linearGradient
          id="paint2_linear_13547_24640"
          x1="12.0008"
          y1="5.39999"
          x2="12.0008"
          y2="17.4"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="white" stopOpacity="0" />
          <stop offset="1" stopColor="white" stopOpacity="0.6" />
        </linearGradient>
      </defs>
    </svg>
  );
};

export const RadioIcon = ({ isActive, className }) => {
  if (isActive) {
    return (
      <svg
        width="14"
        height="14"
        viewBox="0 0 14 14"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={className}
      >
        <g filter="url(#filter0_d_13547_24916)">
          <rect x="1" y="1" width="12" height="12" rx="6" fill="white" />
          <g filter="url(#filter1_di_13547_24916)">
            <rect x="4" y="4" width="6" height="6" rx="3" fill="#4D47DC" />
            <rect
              x="4.5"
              y="4.5"
              width="5"
              height="5"
              rx="2.5"
              stroke="#4D47DC"
            />
          </g>
        </g>
        <defs>
          <filter
            id="filter0_d_13547_24916"
            x="0"
            y="0"
            width="14"
            height="14"
            filterUnits="userSpaceOnUse"
            colorInterpolationFilters="sRGB"
          >
            <feFlood floodOpacity="0" result="BackgroundImageFix" />
            <feColorMatrix
              in="SourceAlpha"
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
              result="hardAlpha"
            />
            <feMorphology
              radius="1"
              operator="dilate"
              in="SourceAlpha"
              result="effect1_dropShadow_13547_24916"
            />
            <feOffset />
            <feComposite in2="hardAlpha" operator="out" />
            <feColorMatrix
              type="matrix"
              values="0 0 0 0 0.388235 0 0 0 0 0.4 0 0 0 0 0.913725 0 0 0 1 0"
            />
            <feBlend
              mode="normal"
              in2="BackgroundImageFix"
              result="effect1_dropShadow_13547_24916"
            />
            <feBlend
              mode="normal"
              in="SourceGraphic"
              in2="effect1_dropShadow_13547_24916"
              result="shape"
            />
          </filter>
          <filter
            id="filter1_di_13547_24916"
            x="3"
            y="4"
            width="8"
            height="8"
            filterUnits="userSpaceOnUse"
            colorInterpolationFilters="sRGB"
          >
            <feFlood floodOpacity="0" result="BackgroundImageFix" />
            <feColorMatrix
              in="SourceAlpha"
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
              result="hardAlpha"
            />
            <feOffset dy="1" />
            <feGaussianBlur stdDeviation="0.5" />
            <feComposite in2="hardAlpha" operator="out" />
            <feColorMatrix
              type="matrix"
              values="0 0 0 0 0.0705882 0 0 0 0 0.0705882 0 0 0 0 0.0705882 0 0 0 0.1 0"
            />
            <feBlend
              mode="normal"
              in2="BackgroundImageFix"
              result="effect1_dropShadow_13547_24916"
            />
            <feBlend
              mode="normal"
              in="SourceGraphic"
              in2="effect1_dropShadow_13547_24916"
              result="shape"
            />
            <feColorMatrix
              in="SourceAlpha"
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
              result="hardAlpha"
            />
            <feMorphology
              radius="1"
              operator="erode"
              in="SourceAlpha"
              result="effect2_innerShadow_13547_24916"
            />
            <feOffset dy="1" />
            <feGaussianBlur stdDeviation="1" />
            <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
            <feColorMatrix
              type="matrix"
              values="0 0 0 0 0.0705882 0 0 0 0 0.0705882 0 0 0 0 0.0705882 0 0 0 0.15 0"
            />
            <feBlend
              mode="normal"
              in2="shape"
              result="effect2_innerShadow_13547_24916"
            />
          </filter>
        </defs>
      </svg>
    );
  }
  return (
    <svg
      width="14"
      height="15"
      viewBox="0 0 14 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <g filter="url(#filter0_dd_13547_24941)">
        <rect x="1" y="1" width="12" height="12" rx="6" fill="white" />
      </g>
      <defs>
        <filter
          id="filter0_dd_13547_24941"
          x="0"
          y="0"
          width="14"
          height="15"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feMorphology
            radius="1"
            operator="dilate"
            in="SourceAlpha"
            result="effect1_dropShadow_13547_24941"
          />
          <feOffset />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.0705882 0 0 0 0 0.0705882 0 0 0 0 0.0705882 0 0 0 0.1 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_13547_24941"
          />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="1" />
          <feGaussianBlur stdDeviation="0.5" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.0705882 0 0 0 0 0.0705882 0 0 0 0 0.0705882 0 0 0 0.1 0"
          />
          <feBlend
            mode="normal"
            in2="effect1_dropShadow_13547_24941"
            result="effect2_dropShadow_13547_24941"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect2_dropShadow_13547_24941"
            result="shape"
          />
        </filter>
      </defs>
    </svg>
  );
};

export const CheckIcon = ({ className }) => (
  <svg
    width="12"
    height="9"
    viewBox="0 0 12 9"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <path
      d="M11.1667 0.5L3.83333 7.83333L0.5 4.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
